import { useEffect, useMemo, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import useAxiosInstance from "../../hooks/useAxios";

export const ReportCard = ({ item, className = '', target, showPinnedIcon = true }: { item: Record<string, any>, className?: string, showPinnedIcon?: boolean }) => {
    return <div to="" className="flex flex-col justify-between p-4 border rounded-lg">
        <div>
            <p className="font-semibold line-clamp-1">{item.label}</p>
            <p className="text-sm line-clamp-2">{item.description}</p>
        </div>
        <Link to={`/edit-report-type/${item.pk}`} className="px-3 py-1 mt-4 text-sm text-left bg-gray-300 rounded hover:bg-gray-400 w-max">Edit</Link>
    </div>
}

export default function ReportTypePreview() {
    const [activeTab, setActiveTab] = useState<'recommended' | 'custom' | 'library'>('recommended')
    const [dashboardCards, setDashboardCards] = useState<Record<string, any>[]>([])
    const [loading, setLoading] = useState(false);
    const axiosInstance = useAxiosInstance();

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .post("/accounts/all_report_types/", {
                page: 1,
                page_size: 99999,
                search_query: '',
                report_category: [],
                extra_boolean_keys: [],
            })
            .then((res) => {
                setLoading(false);
                setDashboardCards(res.data.data);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, []);

    const wokeloWorkflows = dashboardCards?.filter(e => e.meta?.ui_config?.category?.includes('recommended'))
    const customWorkflows = dashboardCards?.filter(e => e.meta?.ui_config?.category?.includes('custom'))
    const libraryWorkflows = useMemo(() => {
        const temp: Record<string, Record<string, any>[]> = {}
        dashboardCards?.filter(e => e.meta?.ui_config?.category?.includes('library')).forEach(card => {
            if (card.meta?.ui_config?.sub_header in temp) {
                temp[card.meta?.ui_config?.sub_header].push(card)
            } else {
                temp[card.meta?.ui_config?.sub_header] = [card]
            }
        })

        Object.values(temp).forEach(arr => {
            arr.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
        })
        return temp
    }, [dashboardCards])

    console.log({ wokeloWorkflows, customWorkflows, dashboardCards })

    return <div className="h-screen mr-2 overflow-y-auto">
        <div className="flex justify-between px-2 py-2 my-2 bg-white border rounded-lg">
            <p className="text-base font-semibold">Preview</p>
        </div>
        <div
            className={'flex flex-col w-full max-w-[1170px] m-0 sm:m-auto'}>
            <div className='flex gap-6 border-b border-[#F7F7F7] px-0 mb-6'>
                <button
                    onClick={() => setActiveTab('recommended')}
                    className={`pb-3 font-Inter-Regular text-base relative ${activeTab === 'recommended'
                        ? 'text-[#141416] font-medium'
                        : 'text-[#6B6B6B]'
                        }`}
                >
                    Recommended
                    {activeTab === 'recommended' && (
                        <div className='absolute bottom-0 left-0 right-0 h-[2px] bg-[#97C8A6]' />
                    )}
                </button>
                <button
                    onClick={() => setActiveTab('custom')}
                    className={`pb-3 font-Inter-Regular text-base relative ${activeTab === 'custom'
                        ? 'text-[#141416] font-medium'
                        : 'text-[#6B6B6B]'
                        }`}
                >
                    Custom
                    {activeTab === 'custom' && (
                        <div className='absolute bottom-0 left-0 right-0 h-[2px] bg-[#97C8A6]' />
                    )}
                </button>
                <button
                    onClick={() => setActiveTab('library')}
                    className={`pb-3 font-Inter-Regular text-base relative ${activeTab === 'library'
                        ? 'text-[#141416] font-medium'
                        : 'text-[#6B6B6B]'
                        }`}
                >
                    Library
                    {activeTab === 'library' && (
                        <div className='absolute bottom-0 left-0 right-0 h-[2px] bg-[#97C8A6]' />
                    )}
                </button>
            </div>
            {/* Recommended Tab Content */}
            {activeTab === 'recommended' && (
                <div className={'grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-full'}>
                    {wokeloWorkflows?.map((item, index) => {
                        return (
                            <ReportCard
                                item={item}
                                key={item?.name + index}
                            />
                        );
                    })}
                </div>
            )}

            {/* Custom Tab Content */}
            {activeTab === 'custom' && (
                <>
                    <div className={'grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-full'}>
                        {customWorkflows?.map((item, index) => {
                            return (
                                <ReportCard
                                    className='border border-[#EEEEEE]'
                                    item={item}
                                    key={item?.name + index}
                                />
                            );
                        })}
                    </div>
                </>
            )}

            {/* Library Tab Content */}
            {activeTab === 'library' && (
                <>
                    <div className='px-0 space-y-8'>
                        {Object.entries(libraryWorkflows).map(([title, list]) =>
                            <div>
                                <h3 className='font-medium font-Inter-Regular text-[#141416] mb-4'>
                                    {title}
                                </h3>
                                <div className={'grid md:grid-cols-2 lg:grid-cols-3 gap-4 w-full mb-8'}>
                                    {list?.map((item, index) => {
                                        return (
                                            <ReportCard
                                                item={item}
                                                key={item?.name + index}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                    </div>
                </>
            )}
        </div>
    </div>
}